import { render, staticRenderFns } from "./ImportacaoArquivo.vue?vue&type=template&id=43133a36&scoped=true&"
import script from "./ImportacaoArquivo.vue?vue&type=script&lang=js&"
export * from "./ImportacaoArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43133a36",
  null
  
)

export default component.exports